module.exports = __webpack_public_path__ + "static/media/ct_logo_color.484a3cc4.svg";